/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as yup from "yup";

export enum FormField {
  NAME = "name",
}

export type FormData = {
  [FormField.NAME]: string;
};

export const schema = yup.object().shape({
  [FormField.NAME]: yup
    .string()
    .required("Filter Preset Name is a required field")
    .min(3, "Minimum 3 characters required"),
});
